import session from './session';
import settings from '../config';
import Events from './events';

let waiting_for_connection = false;
let waiting_for_pong = false;
let ws = null;

export const check_ws_variables = function() {
  return !(waiting_for_connection || waiting_for_pong);
};

export const check_ws_connection = function() {
  if (waiting_for_connection || waiting_for_pong) {
    // console.log("waiting_for_connection || waiting_for_pong", waiting_for_connection, waiting_for_pong)
    waiting_for_pong = false;
    connect();
  } else {
    waiting_for_pong = true;
    ws.send('ping');
  }
};

const CARD_NOTIFICATION_MAP = {
  payment_add_card_finalize: 'wp:card:add:finalize',
  payment_pay_card_finalize: 'wp:card:paid',
  payment_reserve_card_finalize: 'wp:card:reserved',
};

export const connect = () => {
  // console.log('started connecting')
  waiting_for_connection = true;
  const token = session.value().token;
  ws = new WebSocket(settings.notifier_url);

  ws.onerror = event => {
    console.debug('websocket error: ', event);
    return false;
  };

  ws.onopen = () => {
    waiting_for_connection = false;
    // console.log('sending: ' + token)
    ws.send(token);
  };

  ws.onmessage = event => {
    // console.log('received on ws: ', event);
    if (event.data === 'pong') {
      waiting_for_pong = false;
      return;
    }

    try {
      // console.log("noti trying")
      const notification = JSON.parse(event.data);

      if (notification.resource_id in CARD_NOTIFICATION_MAP) {
        // console.log('//===> Card notification: ', notification);
        Events.dispatch(
          CARD_NOTIFICATION_MAP[notification.resource_id],
          notification
        );
        // console.log(
        //   '//===> Event emitted: ',
        //   CARD_NOTIFICATION_MAP[notification.resource_id]
        // );
        return;
      } else {
        Events.dispatch('wp:ws:handle_received_notification', notification);
      }
    } catch (e) {
      console.debug('websocket message error: ', e);
    }
  };
};
